import _every from 'lodash/every';
import { useMemo } from 'react';
import _map from 'lodash/map';
import Stack from '../../../_components/Stack';
import { FeaturedIcon } from '../../FeaturedIcon';
import { Button } from '../../Button';
import type { EmptyStateAsStepProps } from '../types';
import { containerVariants, titleVariants } from '../styles';
import CustomStepper from '../components/CustomStepper';
import EmptyStateTitle from '../components/EmptyStateTitle';
import EmptyStateDescription from '../components/EmptyStateDescription';

function EmptyStateAsStep(props: EmptyStateAsStepProps) {
  const { title, description, Icon, steps, buttons, variant, learnMore } = props;
  const containerClassName = containerVariants({ variant });
  const titleClassName = titleVariants({ variant });
  const allStepsCompleted = useMemo(
    () => _every(steps, (step) => step.isCompleted || step.isOptional),
    [steps],
  );

  return (
    <Stack
      alignItems="start"
      className={containerClassName}
      direction="column"
      justifyContent="end"
    >
      <Stack className="border-tertiary gap-y-2xl pb-xl w-full border-b">
        {Icon ? <FeaturedIcon Icon={Icon} color="gray" size="md" /> : null}
        <Stack>
          <EmptyStateTitle className={titleClassName} title={title} />
          {description ? (
            <EmptyStateDescription description={description} learnMore={learnMore} />
          ) : null}
        </Stack>
      </Stack>
      <CustomStepper steps={steps} />
      {buttons.length ? (
        <Stack className="gap-x-lg pt-2xl" direction="row">
          {_map(buttons, (button, index) => {
            return (
              <Button
                color="brand"
                disabled={!allStepsCompleted}
                key={`${button.label} ${index}`}
                size="md"
                variant="solid"
                {...button}
              >
                {button.label}
              </Button>
            );
          })}
        </Stack>
      ) : null}
    </Stack>
  );
}

export default EmptyStateAsStep;
